import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Routes as RouterRoutes,
  Route,
  Navigate,
  useParams
} from "react-router-dom";
import { connect } from "react-redux";
import { updateVideoCta } from "./Redux/Actions/videos";
import { AuthState } from "../src/Redux/Types/auth";

import Watch from "./Screens/Watch";
import Signup from "./Screens/SignUp";
import SignIn from "./Screens/SignIn";
import Profile from "./Screens/Profile";
import Template from "./Screens/Template";
import MusicAssets from "./Screens/MusicAssets";
import Configuration from "./Screens/Configuration";
import AssetsLibrary from "./Screens/AssetsLibrary";
import ResetPassword from "./Screens/ResetPassword";
import ForgotPassword from "./Screens/ForgotPassword";

import VideoTab from "./Screens/VideoTab/VideoTab";
import UploadRecord from "../src/Screens/UploadRecordVideo";

import Videos from "./Screens/Home/Videos";
import Dashboard from "./Screens/Home/Dashboard";
import Contacts from "./Screens/Connections/Contacts";

import PrivacyPolicy from "./components/PrivacyPolicy";

type IProps = {
  auth: AuthState;
  updateVideoCta: (id: any) => void;
};

// Wrapper component for CTA redirect
function WatchCtaRedirect({ updateVideoCta }: { updateVideoCta: (id: any) => void }) {
  const { id } = useParams();
  React.useEffect(() => {
    if (id) {
      updateVideoCta(id);
    }
  }, [id, updateVideoCta]);
  return <Navigate to={`/watch/${id}`} replace />;
}

class Routes extends Component<IProps> {
  render() {
    return (
      <Router>
        {this.props.auth.loggedInStatus === true ? (
          <RouterRoutes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/videotab/:id" element={<VideoTab />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/video/create" element={<UploadRecord />} />
            <Route path="/watch/:id" element={<Watch />} />
            <Route
              path="/watch/:id/cta"
              element={<WatchCtaRedirect updateVideoCta={this.props.updateVideoCta} />}
            />
            <Route path="/template/" element={<Template />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/contacts" element={<Contacts />} />
            <Route path="/configuration" element={<Configuration />} />
            <Route path="/assetlibrary" element={<AssetsLibrary />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/music" element={<MusicAssets />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </RouterRoutes>
        ) : (
          <RouterRoutes>
            <Route path="/login/*" element={<SignIn />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgotPassword" element={<ForgotPassword />} />
            <Route path="/resetPassword" element={<ResetPassword />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route 
              path="/watch/:id/cta" 
              element={<WatchCtaRedirect updateVideoCta={this.props.updateVideoCta} />} 
            />
            <Route path="/watch/:id" element={<Watch />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </RouterRoutes>
        )}
      </Router>
    );
  }
}
const mapStateToProps = (state: any) => {
  return {
    auth: state.auth,
  };
};
const mapDispatchToProps = (dispatch: any) => {
  return {
    updateVideoCta: (id: any) => dispatch(updateVideoCta(id)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Routes);
